export default "__VITE_ASSET__CNlaRaG5__"